const deletionMethods = [];
window.__uspapi = function(command, version, callback) {
	if (command.toLowerCase() === 'registerdeletion') {
			deletionMethods.push(callback);
	}
	if (command.toLowerCase() === 'performdeletion') {
		deletionMethods.forEach(dm => {
			dm();
		});
	}
};

function addUspapiFrame() {
	if (!window.frames.__uspapiLocator) {
			if (document.body) {
					const body = document.body;
							const iframe = document.createElement('iframe');
					iframe.style.display = 'none';
					iframe.setAttribute('style', 'display:none;height:0;opacity:0;visibility:hidden;border:0;width:0;height:0;');
					iframe.name = '__uspapiLocator';
					body.appendChild(iframe);
			} else {
					setTimeout(addUspapiFrame, 5);
			}
	}
}

addUspapiFrame();
